import React from 'react';
import { EditFormProvider } from './context';
import { TopBar } from './TopBar';
import { IRouterProps } from 'pages/orderHistory';
import { Container } from './Container';

type Params = {
  params?: Record<string, string | undefined>;
};

export const FormsCreate = ({ router, params }: IRouterProps & Params) => {
  return (
    <EditFormProvider params={params} router={router}>
      <TopBar router={router} />
      <Container router={router} />
    </EditFormProvider>
  );
};
